import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { UnresolvedCount } from '../types/data-errors/unresolved-count';

@Injectable({
  providedIn: 'root',
})
export class DataErrorsService {
  constructor(private http: HttpClient) {}

  getUnresolvedCount(): Observable<UnresolvedCount> {
    return this.http.get<UnresolvedCount>('api/data-errors/UnloadedFuelData/unresolved-count')
  }

  getDoubleUnresolvedCount(): Observable<UnresolvedCount> {
    return this.http.get<UnresolvedCount>('api/data-errors/DoubleFuelData/unresolved-count')
  }

  getDifferenceUnresolvedCount(): Observable<UnresolvedCount> {
    return this.http.get<UnresolvedCount>('api/data-errors/differenceRefuelingQuantity/unresolved-count')
  }

  getSapDataUnresolvedCount(): Observable<UnresolvedCount> {
    return this.http.get<UnresolvedCount>('api/data-errors/sapData/unresolved-count')
  }
}
